import React, { Component} from 'react';
import './App.css';

// class App extends Component {
//   render() {
//     return (
//       <div className="App">
//         <header className="App-header">
//           <img src={logo} className="App-logo" alt="logo" />
//           <p>
//           <Link to="/test" activeClassName="active">
//             Edit <code>src/App.js</code> and save to reload.</Link>
//           </p>
//           <a
//             className="App-link"
//             href="https://reactjs.org"
//             target="_blank"
//             rel="noopener noreferrer"
//           >
//             Learn React
//           </a>
//         </header>
//       </div>
//     );
//   }
// }

class App extends Component {
  render() {
    return (
      <div >
        {this.props.children}
      </div>
    );
  }
}

export default App;
